import { Directive, Host, Input, OnDestroy } from '@angular/core';
import { Unsubscribable } from 'rxjs';
import { GridTableComponent } from '../grid/grid-table/grid-table.component';
import { ExportButtonComponent } from './export-button.component';

// Temporary for setting grid while supporting both grids
@Directive({
  selector: 'app-grid-table[exportButton]',
  standalone: false,
})
export class GridExportButtonDirective<T extends {}> implements OnDestroy {
  @Input() set exportButton(value: ExportButtonComponent<T> | null | undefined) {
    this._subscription?.unsubscribe();
    if (value) {
      this._subscription = value.register(this.grid);
    }
  }

  get grid() {
    const grid = this.gridTable;
    if (!grid) {
      throw new Error('No grid');
    }
    return grid;
  }

  private _subscription?: Unsubscribable;

  constructor(@Host() private gridTable: GridTableComponent<T>) {}

  ngOnDestroy() {
    this._subscription?.unsubscribe();
  }
}
